import React from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
  FormControl,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import { TextField } from '@mui/material';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { yupResolver } from "@hookform/resolvers/yup";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { Dialog, DialogContent, Icon, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import HomeIcon from "@mui/icons-material/Home";

// import { D4VALI } from "../../../Validation";
import { Box } from "react-bootstrap-icons";
import moment from "moment";
import { dateFormat } from "../../../utils/Date";
import ComponentLoader from "../../../ComponentLoader";

// import { DatePicker } from '@mui/lab';

function ArE3Inside({ head }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);
  const [loader,setLoader] =useState(true);
  const [Studentbtn, setStudentbtn] = useState([]);
  const [inves, setInves] = useState([]);

  const [investigatorName, setInvestigatorName] = useState("");
  const [eventName, setEventName] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [noofParticiants, setNoofParticipants] = useState("");
  const [beneficiries, setBeneficiries] = useState("");
  const [organizer, setOrganizer] = useState("");
  const [sponsor, setSponsor] = useState("");

  const [investigatorNameErr, setInvestigatorNameErr] = useState(false);
  const [eventNameErr, setEventNameErr] = useState(false);
  const [eventDateErr, setEventDateErr] = useState(false);
  const [noofParticiantsErr, setNoofParticipantsErr] = useState(false);
  const [beneficiriesErr, setBeneficiriesErr] = useState(false);
  const [organizerErr, setOrganizerErr] = useState(false);
  const [sponsorErr, setSponsorErr] = useState(false);

  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");
  const [insti, setInsti] = useState();

  const [token, setToken] = useState("");
  const [id, setId] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const backs = () => {
    navigate("/ArE3");
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    reset,
    watch,
  } = useForm({
    // resolver: yupResolver(D4VALI),
  });

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    if (tok != null && tok != undefined) {
     
      console.log(location.state);
      if (location.state) {
        edit(location.state);
      }
    }
    head("individual scientist");
  }, []);
  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const tok = localStorage.getItem("token");
    const myObject = JSON.parse(objectString);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const institute = localStorage.getItem("loginId");
    setInsti(institute);
    handleInvestigators(tok,institute);
  }, []);
  
  const edit = (item) => {
    console.log(item);
    setInvestigatorName(item.investigatorId);
    setEventName(item.eventName);
    setEventDate(moment(item.eventdate).format("YYYY-MM-DD"));
    setNoofParticipants(item.noOfdays);
    setOrganizer(item.organizedby);
    setSponsor(item.sponsor);
    setId(item.id);
  };

  // Investigator
  const handleInvestigators = async (token,id) => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(`${window.BASE}${window.INVESTIGATORIDMAPNAME}${id}`, {
        headers: h,
      });
      console.log(data);
      setInves(data);setLoader(false);
    } catch (error) {
      console.log(error);setLoader(false);
    }
  };

  const handleLeavepage = async () => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const d = {
      id,
      InvestigatorId: investigatorName,
      EventName: eventName,
      EventDate: dateFormat(eventDate),
      NoOfdays: noofParticiants,
      Organizedby: organizer,
      Sponsor: sponsor,
      IAMRSId: state.id,
      InstituteId: parseInt(insti),
      RptMonth: parseInt(assM),
    };
    if (id === 0) {
      try {
        const { data } = await axios.post(
          `${window.BASE}${window.Er3SAVE}`,
          d,
          {
            headers: h,
          }
        );
        console.log(data);
        setStudentbtn(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/ArE3");
          toastSuccess("Successfully Submitted");
          setId(0);
          setOpen(false);
        } else {
          alert(data.errorMsgs[0]);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(
          `${window.BASE}${window.Er3EDIT}`,
          d,
          {
            headers: h,
          }
        );
        console.log(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/ArE3");
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const formValidateFun = () => {
    if (!investigatorName) {
      setInvestigatorNameErr(true);
      document.getElementById("investigatorName").focus();
    } else if (!eventName) {
      setEventNameErr(true);
      document.getElementById("eventName").focus();
    } else if (!eventDate) {
      setEventDateErr(true);
      document.getElementById("eventDate").focus();
    } else if (!noofParticiants) {
      setNoofParticipantsErr(true);
      document.getElementById("noofParticiants").focus();
    } else if (!organizer) {
      setOrganizerErr(true);
      document.getElementById("organizer").focus();
    } else if (!sponsor) {
      setSponsorErr(true);
      document.getElementById("sponsor").focus();
    } else {
      handleLeavepage();
    }
  };

  return (
    <div className="main-container-margin">
         <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/GeneralAR">
            <HomeIcon style={{ color: "white", marginLeft: 70 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span>E3. Trainings / Meetings / Field days attended</span>
        </div>
      </div>

      <div className="from-mains">
        <div className="form-control">
          <h5 style={{ margin: 20 }}>
            E3. Trainings / Meetings / Field days attended
          </h5>

          <FormControl
            style={{ width: "48%", margin: 12 }}
            error={investigatorNameErr}
            id="investigatorName"
          >
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Name of the faculty
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="investigatorName"
              value={investigatorName}
              label="Programme Type"
              size="small"
              sx={{ width: "100%" }}
              onChange={(e) => {
                setInvestigatorName(e.target.value);
                setInvestigatorNameErr(false);
              }}
            >
              {inves?.map((row, index) => {
                return (
                  <MenuItem key={row.index} value={row.id}>
                    {row.investigatorName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <TextField
            error={eventNameErr}
            id="eventName"
            label="Event Name (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={eventName}
            onChange={(e) => {
              setEventName(e.target.value);
              setEventNameErr(false);
            }}
          />

          <TextField
            error={noofParticiantsErr}
            id="noofParticiants"
            label="No. of Days (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={noofParticiants}
            onChange={(e) => {
              setNoofParticipants(e.target.value);
              setNoofParticipantsErr(false);
            }}
          />

          <TextField
            error={eventDateErr}
            id="eventDate"
            label="Event Date"
            variant="outlined"
            type="date"
            value={eventDate}
            onChange={(e) => {
              setEventDate(e.target.value);
              setEventDateErr(false);
            }}
            style={{ margin: "10px", width: "48%" }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              placeholder: "",
            }}
          />

          {/* <TextField
            error={beneficiriesErr}
            id="beneficiries"
            label="Beneficiaries (Max 250 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={beneficiries}
            onChange={(e) => {
                setBeneficiries(e.target.value)
                setBeneficiriesErr(false)
              }}
          /> */}

          <TextField
            error={organizerErr}
            id="organizer"
            label="Organized by (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={organizer}
            onChange={(e) => {
              setOrganizer(e.target.value);
              setOrganizerErr(false);
            }}
          />

          <TextField
            error={sponsorErr}
            id="sponsor"
            label="Sponsor (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={sponsor}
            onChange={(e) => {
              setSponsor(e.target.value);
              setSponsorErr(false);
            }}
          />

          <div className="from-last">
            <button
              type="submit"
              style={{
                backgroundColor: "#008CBA",
                height: "20px",
                padding: "5px 30px 28px 26px",
                borderRadius: "3px",
                color: "#fff",
              }}
              onClick={backs}
            >
              Back
            </button>
            <button
              type="submit"
              className="sbmit-buttons"
              onClick={formValidateFun}
              style={{ paddingTop: "5px" }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArE3Inside;
